import { logoutBySSO, getUserInfo, exchangeToken } from '@/api/account';
import http from '@/core/http';
import { ENV_PREFIX } from '@/core/http/env';
import { defineStore } from 'pinia';
import { useMenuStore } from '../menu';
import { IState, IStoreAccount } from './type.d';
import { SYSTEM_ENUM } from '@/constant';
import { ICompanyInfoItem } from '@/api/account/type';
import { jumpSSOLogout } from '@/core/utils/router';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';

const accountStorage = {
  tokenKey: `${SYSTEM_ENUM.OPS}-tokenKey-${ENV_PREFIX}`,
  companyKey: `${SYSTEM_ENUM.OPS}-companyKey-${ENV_PREFIX}`,
  getToken(): string {
    return localStorage.getItem(this.tokenKey) || '';
  },
  setToken(token: string) {
    return localStorage.setItem(this.tokenKey, token);
  },
  removeToken() {
    return localStorage.removeItem(this.tokenKey);
  },
  getCompany(): string {
    const token = localStorage.getItem(this.companyKey);
    return token || '';
  },
  setCompany(token: string) {
    localStorage.setItem(this.companyKey, token);
  },
  removeCompany() {
    return localStorage.removeItem(this.companyKey);
  },
};

const initToken = () => {
  const token = accountStorage.getToken();
  http.account = Object.assign({}, http.account || {}, { ssoToken: token });
  return token;
};

export const useAccountStore = defineStore({
  id: 'account',
  state: (): IState => ({
    account: null,
    token: initToken(),
    currentCompany: null,
  }),
  // 定义修改state数据函数
  actions: {
    // 设置当前租户
    setCurrentCompany(currentCompany: ICompanyInfoItem) {
      this.currentCompany = currentCompany;
      http.account = Object.assign(
        { ssoToken: this.token! },
        http.account || {},
        { currentCompanyInfo: currentCompany },
      );
      accountStorage.setCompany(currentCompany.companyId);
    },
    setCurrentAccount(account: IStoreAccount) {
      this.account = account;
      http.account = Object.assign({ ssoToken: this.token! }, http.account || {}, account);
    },
    setCurrentToken(token: string) {
      this.token = token;
      http.account = Object.assign({}, http.account || {}, { ssoToken: token });
      accountStorage.setToken(token);
    },
    async exchangeToken(code: string) {
      try {
        if (this.token) return;
        const { data } = await exchangeToken(code);
        this.setCurrentToken(data.ssoToken);
      } catch (e) {
        console.log(e);
      }
    },
    // 处理租户
    handleCompany() {
      const account = this.account!;
      // 判断租户列表
      if (account.companyInfoList && account.companyInfoList.length && account.companyInfoList.length === 1) {
        this.setCurrentCompany(account.companyInfoList[0]);
        return;
      }
      const companyId = accountStorage.getCompany();
      // 租户Id
      if (companyId) {
        const findItem = account.companyInfoList.find(it => it.companyId === companyId);
        if (findItem) {
          this.setCurrentCompany(findItem);
        }
      }
      // todo 不存在 跳转租户选择页面。
    },
    async getAccountInfo() {
      try {
        if (this.account) return;
        const { data } = await getUserInfo();
        this.setCurrentAccount(data);
        this.handleCompany();
      } catch (e) {
        console.log(e);
      }
    },
    async logout(isExpiration = false) {
      const menuStore = useMenuStore();
      try {
        if (!isExpiration) {
          await logoutBySSO();
        }
        this.token = '';
        this.account = null;
        this.currentCompany = null;
        accountStorage.removeToken();
        menuStore.clearMenus();
        accountStorage.removeCompany();
        http.account = null;
        const url = http.systemDomainMap[DOMAIN_SYSTEM_ENUM.SSO];
        if (url) {
          jumpSSOLogout(url);
        }
      } catch (error) {
        console.log('logout error', error);
      }
    },
  },
});

http.logout = async (isExpiration) => {
  await useAccountStore().logout(isExpiration);
};
